import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tpc-air-travel',
  templateUrl: './air-travel.component.html',
  styleUrls: ['./air-travel.component.css']
})
export class AirTravelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/air-travel/air-travel.component.ts